"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableMarkerOffset = void 0;
const core_api_1 = require("@ikegps/core-api");
const vector_1 = require("../../../math/vector");
const drawable_1 = require("./drawable");
const label_drawable_1 = require("./label.drawable");
/**
 * MarkerOffset drawable has its position set dynamically using to the Base Marker's "offset" property.
 * Technically it has no (x,y) state since that is computed from the capture and the Base Marker.
 */
class CollectionModelDrawableMarkerOffset extends drawable_1.MoveableDrawable {
    static createWithLabel(drawableState, labelPoint) {
        const marker = new CollectionModelDrawableMarkerOffset(drawableState);
        if (!labelPoint) {
            labelPoint = {
                x: 0,
                y: marker.y,
            };
        }
        const label = new label_drawable_1.CollectionModelDrawableLabel(drawableState, marker.labelId, labelPoint.x, labelPoint.y, marker.id);
        return { marker, label };
    }
    constructor(collectionModelDrawableState, id = CollectionModelDrawableMarkerOffset.DEFAULT_DRAWABLE_ID, labelId = CollectionModelDrawableMarkerOffset.DEFAULT_LABEL_ID) {
        super(collectionModelDrawableState, id);
        this._labelId = labelId;
    }
    static isBaseOffset(t) {
        return t instanceof CollectionModelDrawableMarkerOffset;
    }
    get labelId() {
        return this._labelId;
    }
    get label() {
        return this.drawableState.getDrawable(this.labelId);
    }
    getLabelConnectionPoint(options) {
        return {
            x: this.label.isOnLeftSide()
                ? this.x - options.draw.state.markerOffsetWidth // Left
                : this.x + options.draw.state.markerOffsetWidth, // Right
            y: this.y,
        };
    }
    get x() {
        if (this.drawableState.capture == null) {
            return 0;
        }
        return this.drawableState.capture.resolution.width / 2;
    }
    get y() {
        var _a;
        const base = this.drawableState.base;
        if (base == null || this.drawableState.capture == null) {
            return 0;
        }
        const baseXY = base.getVector();
        const moveAmount = new vector_1.Vector(0, (_a = base.offset) !== null && _a !== void 0 ? _a : 0);
        return this.drawableState.collection.state.getGeometry(this.captureId).movePoint(baseXY, moveAmount).y;
    }
    // The offset marker position is relative to the Base marker,
    // so adjust the move location of the Base marker by applying a negative base offset.
    move(x, y) {
        var _a;
        if (!this.drawableState.base || this.drawableState.capture == null) {
            return;
        }
        const clickPoint = new vector_1.Vector(x, y);
        const offset = new vector_1.Vector(0, -1 * ((_a = this.drawableState.base.offset) !== null && _a !== void 0 ? _a : 0));
        const offsetY = this.drawableState.collection.state.getGeometry(this.captureId).movePoint(clickPoint, offset).y;
        this.drawableState.base.move(x, offsetY);
    }
    get type() {
        return core_api_1.MarkerType.BASE_OFFSET;
    }
    get isDeletable() {
        return false;
    }
    remove() {
        super.remove();
        // Remove this offset marker's label too, unless it has already been removed
        if (this.drawableState.hasDrawable(this.labelId)) {
            this.label.remove();
        }
    }
    get isInsightMeasurement() {
        return false;
    }
    isApprovableInsightDrawable() {
        return false;
    }
    get isVisible() {
        return true;
    }
    clone(newParentDrawableState) {
        if (!newParentDrawableState.hasDrawable(this.labelId)) {
            this.label.clone(newParentDrawableState);
        }
        return new CollectionModelDrawableMarkerOffset(newParentDrawableState, this.id, this._labelId);
    }
    equals(other) {
        return other instanceof CollectionModelDrawableMarkerOffset && this._equals(other);
    }
}
exports.CollectionModelDrawableMarkerOffset = CollectionModelDrawableMarkerOffset;
CollectionModelDrawableMarkerOffset.DEFAULT_DRAWABLE_ID = 'offset';
CollectionModelDrawableMarkerOffset.DEFAULT_LABEL_ID = 'offset:label';
//# sourceMappingURL=marker.offset.drawable.js.map